<template>
  <m-form
    title="انبار گردانی"
    :showList="false"
    :listRoute="{ name: 'WarehouseHandlingList' }"
    exportBaseUrl="reports/lists/warehouseHandlings"
    :exportParams="{ id: this.id }"
    :canDelete="canDelete"
    :canSubmit="canSubmit"
    :isEditing.sync="isEditing"
    @goToForm="getItemByPosition"
    @submit="submit"
    @delete="deleteItem"
    @clearForm="clearForm()"
    ref="mForm"
  >
    <template #header-btns>
      <template v-if="item.is_defined">
        <span>
          <v-btn
            :to="{
              name: 'AdjustmentForm',
              params: { id: item.inputAdjustment, type: 'ia' },
            }"
            class="blue white--text mr-1 mt-1 mt-md-0"
            >مشاهده رسید</v-btn
          >

          <v-btn
            :to="{
              name: 'AdjustmentForm',
              params: { id: item.outputAdjustment, type: 'oa' },
            }"
            class="blue white--text mr-1 mt-1 mt-md-0"
            >مشاهده حواله</v-btn
          >
        </span>
      </template>

      <template v-if="$refs.mForm && id">
        <span>
          <v-btn
            :block="isXs"
            small
            class="export-btn mr-1 mt-1 mt-md-0"
            :href="$refs.mForm.printUrl + '&hide_remains=true'"
            target="_blank"
            rel="noopener noreferrer"
            >چاپ بدون مانده</v-btn
          >
          <v-btn
            small
            class="export-btn mr-1 mt-1 mt-md-0"
            :href="$refs.mForm.pdfUrl + '&hide_remains=true'"
            rel="noopener noreferrer"
            >PDF بدون مانده</v-btn
          >
          <v-btn
            small
            class="export-btn mr-1 mt-1 mt-md-0"
            @click="downloadUrl($refs.mForm.excelUrl + '&hide_remains=true')"
            >اکسل بدون مانده</v-btn
          >
        </span>
      </template>
    </template>

    <template>
      <v-row>
        <v-col cols="12" md="2">
          <v-text-field disabled label="شماره" v-model="item.code" />
        </v-col>
        <v-col cols="12" md="2">
          <date v-model="item.start_date" label=" * تاریخ آغاز" :default="true" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12" md="2">
          <date v-model="item.counting_date" label=" * تاریخ شمارش" :default="true" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12" md="2">
          <date v-model="item.submit_date" label=" * تاریخ ثبت انبار گردانی" :default="true" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12" md="2">
          <mtime label="* ساعت ثبت انبار گردانی" v-model="item.submit_time" :default="true" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field label="* انبار گردان" v-model="item.handler" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            :return-object="false"
            label="* انبار"
            :items="warehouses"
            v-model="filters.warehouse"
            item-text="title"
            item-value="id"
            :disabled="id != undefined"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-select :items="waresStatuses" v-model="filters.status" label="وضعیت کالا" :disabled="id != undefined" />
        </v-col>
        <v-col cols="12" md="3">
          <v-textarea label="شرح" v-model="item.explanation" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12" md="3">
          <v-checkbox v-if="!this.id" label="ورود اطلاعات از طریق اکسل" v-model="byExcel" :value="true"></v-checkbox>
        </v-col>

        <v-col cols="12" v-if="byExcel">
          <v-row>
            <v-col cols="12" md="2">
              <v-btn
                block
                color="light-blue white--text"
                class="mt-md-1"
                :href="getTemplateUrl()"
                target="_blank"
                tag="a"
                rel="noopener noreferrer"
                >دانلود قالب
              </v-btn>
            </v-col>
            <v-col cols="12" md="7">
              <m-file-input block label="فایل" v-model="file" ref="fileInput" />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" v-else>
          <m-datatable
            :headers="headers"
            :items="rows"
            :showExportBtns="false"
            :showAppliedFilters="false"
            :showClearFiltersBtn="true"
            :showSelect="false"
            :filters.sync="datatableFilters"
            v-if="filters.warehouse"
          >
            <template #item.warehouse_remain="{ item }">
              <money v-model="item.warehouse_remain" :disabled="!isEditing" />
            </template>
            <template #item.system_remain="{ item }">
              {{ getSystemRemain(item) | toMoney }}
            </template>
            <template #item.contradiction="{ item }">
              <span dir="ltr" :class="getContradictionStyle(item)">
                {{ getContradiction(item) | toMoney }}
              </span>
            </template>
            <template #item.explanation="{ item }">
              <row-textarea
                v-model="item.explanation"
                :disabled="!isEditing"
                :i="rows.indexOf(item)"
                @updateRowsExplanation="updateRowsExplanation"
              />
            </template>
          </m-datatable>
        </v-col>
      </v-row>
    </template>

    <template #footer-outside-btns>
      <v-btn v-if="id" @click="definite" :disabled="item.is_defined" class="blue white--text mr-1">ثبت نهایی</v-btn>
    </template>
  </m-form>
</template>

<script>
import money from "@/components/mcomponents/cleave/Money";
import mtime from "@/components/mcomponents/cleave/Time";
import date from "@/components/mcomponents/cleave/Date";
import wareApiMixin from "@/mixin/wareApi";
import { MFormMixin } from "@/components/m-form";

export default {
  name: "Form",
  components: { money, date, mtime },
  mixins: [wareApiMixin, MFormMixin],
  props: ["id"],
  data() {
    return {
      permissionBasename: "warehouseHandling",
      appendSlash: true,
      hasList: false,
      hasIdProp: true,
      hasLock: true,
      filters: {},
      datatableFilters: {},
      inventory: [],
      rows: [],
      file: null,
      formData: false,
      byExcel: false,
    };
  },
  computed: {
    baseUrl() {
      if (this.byExcel) return "factors/warehouseHandlings/byExcel";
      return "factors/warehouseHandlings";
    },
    headers() {
      let headers = [
        {
          text: "کد کالا",
          value: "ware.code",
          align: "center",
          sortable: true,
          filterable: true,
        },
        {
          text: "نام کالا",
          value: "ware.name",
          align: "center",
          sortable: true,
          filterable: true,
        },
        {
          text: "واحد",
          value: "unit",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "* موجودی شمارش شده انبار",
          value: "warehouse_remain",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "مانده سیستم",
          value: "system_remain",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "مغایرت",
          value: "contradiction",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "توضیحات",
          value: "explanation",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ];
      return headers;
    },
  },
  watch: {
    filters: {
      handler() {
        this.getWareInventory();
      },
      deep: true,
    },
    byExcel() {
      this.formData = this.byExcel;
    },
  },
  created() {
    this.getWares();
    this.getWarehouses();
    this.filters = this.getFilterTemplate();
  },
  methods: {
    getWareInventory() {
      this.request({
        url: this.endpoint("reports/inventory/warehouse/all"),
        params: {
          ...this.filters,
          level: 3,
          limit: 1000000,
          offset: 0,
        },
        success: (data) => {
          data = data.results.slice(0, data.results.length - 1);
          this.inventory = data;
          if (!this.id) {
            this.rows = data.map((o) => {
              return {
                id: null,
                ware: o,
                system_remain: o.remain,
              };
            });
          }
        },
      });
    },
    getTemplateUrl() {
      const params = {
        ...this.filters,
        level: 3,
        limit: 1000000,
        offset: 0,
      };

      let url = this.endpoint(this.baseUrl);
      url += "?";
      for (const [key, value] of Object.entries(params)) {
        url += key + "=" + value + "&";
      }
      url += "token=" + this.token;
      return url;
    },
    submit(clearForm = true) {
      if (!this.confirm()) return;

      if (this.item.id) this.updateItem(clearForm);
      else this.storeItem(clearForm);
    },
    definite() {
      if (!this.confirm()) return;
      this.request({
        url: this.endpoint("factors/warehouseHandlings/definite"),
        method: "post",
        data: {
          id: this.id,
        },
        success: (data) => {
          this.successResponse(data);
        },
      });
    },
    confirm() {
      if (this.item.is_defined) return true;
      return confirm("با انجام این عملیات مانده سیستم به روز رسانی می شود");
    },
    clearForm() {
      this.isEditing = true;
      this.item = this.getItemTemplate();
      this.filters = this.getFilterTemplate();
      this.changeRouteTo(null);
    },
    getFilterTemplate() {
      return {
        warehouse: null,
        level: 3,
        status: "all",
      };
    },
    getSystemRemain(row) {
      if (!this.id) {
        row.system_remain = this.inventory.filter((o) => o.id == row.ware.id)[0]["remain"];
      }
      return row.system_remain;
    },
    getContradiction(row) {
      const systemRemain = this.getSystemRemain(row);
      if (!row.warehouse_remain && row.warehouse_remain != 0) {
        row.contradiction = systemRemain;
        return "-";
      }
      row.contradiction = this.getSystemRemain(row) - row.warehouse_remain || 0;
      return row.contradiction;
    },
    getContradictionStyle(row) {
      let contradiction = this.getContradiction(row);
      if (!row.warehouse_remain) return "";
      if (contradiction > 0) return "green--text";
      else return "red--text";
    },
    getItemTemplate() {
      return {};
    },
    setItem(item) {
      this.item = item;
      this.filters.warehouse = item.warehouse.id;
      this.filters.status = item.ware_status;
      this.itemsToDelete = [];
      this.rows = [];
      item.items
        .sort((a, b) => a.order - b.order)
        .forEach((item) => {
          let row = { ...item };
          this.rows.push(row);
        });
      this.changeRouteTo(item.id);
      this.isEditing = false;
      this.byExcel = false;
    },
    getSerialized() {
      let item = {
        ...this.item,
        warehouse: this.filters.warehouse,
        ware_status: this.filters.status,
      };
      delete item.items;
      let data = {
        item: this.extractIds(item),
      };
      if (this.byExcel) {
        data.file = this.file;
      } else {
        data.items = {
          items: this.getSerializedRows(),
          ids_to_delete: this.itemsToDelete,
        };
      }
      return data;
    },
    getSerializedRows() {
      let serializedRows = [];
      for (let row of this.rows) {
        row = this.extractIds(row);
        const rowFields = ["ware", "warehouse_remain", "system_remain", "order", "explanation"];

        if (row.id) {
          let isChanged = false;
          const originalRow = this.extractIds(this.item.items.filter((o) => o.id == row.id)[0]);
          for (const field of rowFields) {
            if (originalRow[field] != row[field]) {
              isChanged = true;
              break;
            }
          }
          if (!isChanged) continue;
        }

        let serializedRow = {
          id: row.id,
        };
        for (const field of rowFields) serializedRow[field] = row[field];

        serializedRows.push(serializedRow);
      }
      return serializedRows;
    },
  },
};
</script>

<style scoped lang="scss"></style>
